import {
  Input,SimpleChanges,OnChanges,
  Component,
  OnInit
} from '@angular/core';
import {Router, ActivatedRoute, Params} from '@angular/router';
import {ImageVM} from "../../models/ImageVM.model";
import {CompanyVM} from "../../models/CompanyVM.model";
import {CompanyService} from "../../services/company-service/company-service";
import {SharingService} from "../../services/sharing/sharing.service";
import {AuthService} from "../../services/auth/AuthService";
import {LoginComponent} from "../../login/login.component";
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import {IAppConfig} from "../../models/app-config.model";
import {AppConfig} from "../../services/app.config";
import {API_URL_IMAGE_BY_IMAGE_ID, API_URL_IMAGE_THUMB_BY_IMAGE_ID} from "../../services/constants";


@Component({

  selector: 'rw-navbar-modern',  // <home></home>

  styles: [require('./navbar-modern.component.scss')],

  template: require('./navbar-modern.component.html'),
  host: {
    '(window:resize)': 'onResize($event)'
  }

})
export class NavbarModernComponent implements OnInit,OnChanges {

  company:CompanyVM;
  public coverImage:ImageVM;
  public imageUrl:String;
  public logo : any ;
  mobileScreen:boolean = false;
  servantListAccessModeIsMENU: boolean = false;
  public servant_label = 'پرسنل';
  public setting:IAppConfig=AppConfig.settings;
  public noPasswordLoginEnabled=false;
  /**
   * TypeScript public modifiers
   */
  constructor(private sharingService:SharingService, private router:Router, private activatedRoute:ActivatedRoute
              , private companyService:CompanyService,public authService: AuthService,
              public dialog: MatDialog,
  ) {

  }
  public imageList:ImageVM[];

  public ngOnInit() {
    if (window.innerWidth > 767){
      this.mobileScreen = false;
    } else {
      this.mobileScreen = true;
    }


  let parent=this;
    this.companyService.getCompanyInfo().subscribe((c)=> {
      parent.company = c;
      parent.companyService.getCompanyLogoImage(c).subscribe(((logo) => {
        parent.logo = logo;
      }));


      let accessMode = this.companyService.getCompanyCustomSetting(this.company, 'servant_list_access_mode');
      if (accessMode === 'MENU') {
        this.servantListAccessModeIsMENU = true;
      }
      //dont change the servantListAccessModeIsMENU bcz you will forget to delete this line
      //  this.servantListAccessModeIsMENU = true; //this line is for testing and should be deleted
      let serLabel = this.companyService.getCompanyCustomSetting(this.company, 'servants_label');
      if (serLabel) {
        parent.servant_label = serLabel;
      }

      let noPasswordEnabled=parent.companyService.getCompanyCustomSetting(this.company, 'noPassLoginEnabled');
      if(noPasswordEnabled)
        parent.noPasswordLoginEnabled=noPasswordEnabled;

    })

  }

  ngOnChanges(changes:SimpleChanges):void {

    let parent = this;
  }


  openLoginDialog(): void {
    //this.authGuard.openLoginDialog();
    let dialogRef = this.dialog.open(LoginComponent, {
      width: '600px',
      data: {name: 'saeed',noPasswordLoginEnabled:this.noPasswordLoginEnabled}
    });

    dialogRef.afterClosed().subscribe(result => {
      this.authService.updateLoginStatus();

    });
  }

  logout() {
    this.authService.logout();
    const event = new Event("loggedOut");
    window.dispatchEvent(event);
  }


  onResize(event){
    if (window.innerWidth > 767){
      this.mobileScreen = false;
    } else {
      this.mobileScreen = true;
    }
  }

  getLogoPath() {
    if (this.logo) {
        return  'url("' + API_URL_IMAGE_BY_IMAGE_ID + "?imageDataId=" + this.logo.id + '")';
    }

    return '';
  }

}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/component/navbar-modern/navbar-modern.component.ts